import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ChangelogService } from './changelog.service';

@Injectable({
  providedIn: 'root',
})
export class ChangelogUpdatesService {
  private readonly changelogService = inject(ChangelogService);
  private readonly translate = inject(TranslateService);

  private readonly unseen = signal(false);
  private consulted = false;
  private pendingCheck: Promise<void> | null = null;

  public readonly hasUnseenUpdates = this.unseen.asReadonly();

  public check(): Promise<void> {
    this.pendingCheck ??= this.changelogService
      .hasUnseenUpdates(this.translate.getCurrentLang() ?? 'nl')
      .then((unseen) => this.unseen.set(unseen === true && !this.consulted))
      .catch(() => {
        this.pendingCheck = null;
      });

    return this.pendingCheck;
  }

  public enterPage(): void {
    // Post only after the check: on a deep link to the page the visit would otherwise hide the dot.
    this.check()
      .then(() => this.changelogService.markSeen())
      .catch(() => undefined);
  }

  public leavePage(): void {
    this.consulted = true;
    this.unseen.set(false);
  }
}
